import {
  AfterViewInit,
  Directive,
  ElementRef,
  Injector,
  Input,
  OnDestroy
} from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import Inputmask from 'inputmask';
import { Calendar } from 'primeng/calendar';

@Directive({
  selector: '[sigvPrimeCalendarInputMask]',
})
export class PrimeCalendarInputMaskDirective
  implements AfterViewInit, OnDestroy{
  constructor(private el: ElementRef, private calendar: Calendar, private injector: Injector, ) {}

  @Input('sigvPrimeCalendarInputMask') dateMask!: string;

  inputElement: HTMLInputElement | null = null;
  private _control: AbstractControl | null = null;

  get control(): AbstractControl | null {
    const ngControlDirective = this.injector.get(NgControl);
    const control = ngControlDirective.control as any | null;
    if (control) {
      this._control = control;
    }

    return this._control;
  }

  ngAfterViewInit(): void {
    this.inputElement = this.el.nativeElement.querySelector('input');

    if (this.dateMask && this.inputElement) {
      const options = {
        oncomplete: () => {
          this.onInput();
        }
      };
      const im = new Inputmask(this.dateMask, options);
      im.mask(this.inputElement);

      // 新增 Paste 事件，加上 inputMask 後，貼上文字時不會觸發 calendar 內部 input 的 input 事件
      this.inputElement.addEventListener('paste', this.pasteEvent.bind(this));
    }
  }

  // 因中文輸入法輸入問題另行抓值
  onInput(): void {
    let parsedDate: Date | null;
    try {
      const inputElement = this.el.nativeElement.querySelector('input');
      parsedDate = this.calendar.parseValueFromString(inputElement.value) as Date;
    } catch (e) {
      parsedDate = null;
    }
    if (parsedDate) {
      this.control?.setValue(parsedDate);
      this.control?.updateValueAndValidity();
    }
  }

  ngOnDestroy(): void {
    this.inputElement?.removeEventListener('paste', this.pasteEvent.bind(this));
  }

  private pasteEvent(event: Event): void {
    if (event.target) {
      // 觸發 calendar 內部 Input 的 input 事件
      this.calendar.onUserInput(event);
    }
  }
}
